<template>
    <div class="workScheduleAssignment" :style="itemStyle"></div>
</template>

<script lang="ts">
    import {CSSProperties} from 'vue';
    import {PlanbordWorkSchedulePosition} from '@/types/api-object-extensions';
    import WorkScheduleUtil from '@/util/WorkScheduleUtil';
    import {WorkScheduleGridPosition} from '@/types/types';
    import {WorkScheduleAssignment} from '@cquential/api';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class WorkScheduleAssignmentComponent extends Vue {
        @Prop({required: true}) public workSchedulePosition!: PlanbordWorkSchedulePosition;
        @Prop({required: true}) public workScheduleAssignment!: WorkScheduleAssignment;
        @Prop({required: true}) public beginDateTimeWorkSchedule!: Date;
        @Prop({required: true}) public endDateTimeWorkSchedule!: Date;

        public get itemStyle(): CSSProperties {
            const position: WorkScheduleGridPosition = WorkScheduleUtil.getPositionInHours(this.beginDateTimeWorkSchedule, this.workScheduleAssignment.beginDateTime, this.workScheduleAssignment.endDateTime);

            return {
                '--offset-left': 'calc(' + position.left + ' * var(--hour-cell-width))',
                '--width': 'calc(' + position.width + ' * var(--hour-cell-width))',
            };
        }
    }
</script>

<style lang="scss" scoped>
    .workScheduleAssignment {
        position: absolute;
        top: 0;
        bottom: 0;
        left: var(--offset-left, 0);
        width: var(--width, 0);
        box-sizing: border-box;
        background: var(--work-schedule-assigned-background);
        padding: var(--cell-padding);
    }
</style>
